import { useState } from "react";
import { Tooltip, Popover, notification } from "antd";
import dots from "../../../../assets/images/dots.svg";
import calendar from "../../../../assets/images/calendar.svg";
import noteIcon from "../../../../assets/images/note-gray.svg";
import noteGray from "../../../../assets/images/gray-note.svg";
// import { getBlob } from "utilities/GetBlobUrl";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { handleDownload } from "views/pages/Invoice/utils";
import CommonAction from "stores/common/CommonAction";
import { useDispatch } from "react-redux";
import environment from "environment";


const CustomCard = ({
  id,
  dateclassname,
  imgicon,
  notes,
  notescontent,
  notesclass,
  notesimageclass,
  cardtitle,
  pagenumberclassname,
  pagenumbercontent,
  pagenumber,
  pdfname,
  pdfclassname,
  spanbodycontent,
  spanclassname,
  recentlyUpdatedBy,
  extracted_time,
  version_history,
  sas_excel_link,
  sas_document_link,
  notes_data,
  record,
  file_name,
  extraction_status,
  receiver_name,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [showdropdown] = useState(false);
  const [visible, setVisible] = useState(false);

  const handlePopoverVisibleChange = (visible) => {
    setVisible(visible);
  };
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);

    const options = {
      weekday: "short",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "Europe/Paris",
    };

    const formatter = new Intl.DateTimeFormat(t("currentLanguage"), options);
    const formattedDate = formatter.format(date);

    // Normal Code
    // return formattedDate.replace(/,/g, "");

    // Capitalization code
    const capitalize = str => str
    .split(' ') 
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) 
    .join(' '); 
    const capitalizedDate = capitalize(formattedDate.replace(/,/g, ""));
    return capitalizedDate;
    
  };

  const recipientNameHandle = (name) => {
    if (!name || name === "") {
      return "NA";
    }
    let nameParts = name.split(" ");

    if (nameParts.length === 1) {
      let singleNameInitials = nameParts[0].substring(0, 2).toUpperCase();
      return singleNameInitials;
    }

    let firstNameInitial = nameParts[0].charAt(0);
    let lastName = nameParts[1];

    let lastNameInitials =
      lastName.length >= 2 ? lastName.substring(0, 2) : lastName.charAt(0);

    return `${firstNameInitial}${lastNameInitials}`;
  };
  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  const initials = recipientNameHandle(recentlyUpdatedBy);

  const items = [
    getItem("", "", <img src={dots} alt="dots" />, [
      getItem("Edit", "1"),
      getItem("Download", "1"),
      getItem("Version History", "1"),
    ]),
  ];

  const Popup = ({ data }) => {
    const sortedData = [...data].sort((a, b) =>
      b.modified_at_CET.localeCompare(a.modified_at_CET)
    );
    sortedData.forEach((data) => {
      data.document_status = data.document_status
        ? data.document_status
        : notescontent;
    });
    return (
      <div className="col-md-12 text-start vh-popover px-0 mt-8 horizontal-scrollbar">
        <div>
          <div className="history-header pb-0">
            <h1 className="dark-text fs14 mb-2 poppins-medium">
              {t("versionHistory")}
            </h1>
          </div>
          {sortedData.map((item, index) => (
            <div key={index} className="popup-item px-3 pt-1 pb-2">
              <div className="d-flex align-items-center">
               <div className="username pe-3">
                <div className="fs12 poppins-medium dark-text text-lowercase text-truncate">{item.modified_by}:</div>
                <div className="fs12 cell-gray">{formatDate(item.modified_at_CET)}</div>
               </div>
                {" "}
                <span
                  className={
                    item.document_status === "not-started-card fs11 ms-2 status-width"
                      ? "not-started-card ms-2 fs11 status-width"
                      : `${item.document_status}-span ms-2 fs11 status-width`
                  }
                >
                  {translateStatus(item.document_status)}
                </span>
                 {item.status ? (
                  <span className="status-span ms-2 fs11">
                    {translateStatus(item.status)}
                  </span>
                ) : (
                  <span className="status-span ms-2 fs11">
                    {translateStatus("Updated")}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  const popoverContent = (
    <div>
      {items[0].children.map((child) => {
        const uniqueKey = `popover-${child.key}-${child.label}`;

        if (child.label === "Version History") {
          return (
            <Popover
              key={uniqueKey}
              placement="bottomLeft"
              overlayClassName="ant-popover-history"
              content={<Popup data={version_history} />}
              trigger="click"
            >
              <div className="list-items">
                <p role="button">{t("versionHistory")}</p>
              </div>
            </Popover>
          );
        } else if (child.label === "Download") {
          return (
            <div className="list-items" key={uniqueKey}>
              <p role="button" onClick={() => handleOnDownload()}>
                {t("download")}
              </p>
            </div>
          );
        } else {
          return (
            <div className="list-items" key={uniqueKey}>
              <p role="button" onClick={() => handleEdit()}>
                {t("edit")}
              </p>
            </div>
          );
        }
      })}
    </div>
  );

  const handleOnDownload = async () => {
    await handleDownload(sas_document_link);

    if (environment.APP_ENVIRONMENT !== 'alabusTesting') {
      // Disabling download excel for alabus client
      if (sas_excel_link) {
        setTimeout(async () => {
          await handleDownload(sas_excel_link);
        }, 3000);
      }
    }
  };

  const handleEdit = () => {
    if (
      extraction_status === "invalid_file_format" ||
      extraction_status === "invalid_pet_invoice" ||
      extraction_status === "extraction_issue"
    ) {
      notification.error({ message: t("notAllowedToEdit") });
    } else {
      
      const position = window.scrollY;
      dispatch(CommonAction.setSelectedDocument(id));
      dispatch(CommonAction.setCurrentPosition(position));
      navigate(`/invoice/${id}`);
    }
  };

  const translateStatus = (status) => {
    return t(status);
  };

  return (
    <>
      <div id={id} className="card-dashboard">
        <div className="card-header bg-transparent border-bottom-0px">
          <div className="d-flex justify-content-between align-items-center">
                <>
                  <div className="d-flex gap9 align-items-center">
                    <span role="button" className={notesclass} mr9>
                      {translateStatus(notescontent)}
                    </span>
                    <img
                      role="button"
                      src={imgicon}
                      alt="icon"
                      className=""
                    />
                  </div>
                  <div className="">
                    {notes_data?.trim().length && (
                      <Popover
                        content={notes_data ? notes_data : t("no_content")}
                        trigger="click"
                        overlayClassName="notes-popover"
                      >
                        <img
                          role="button"
                          src={noteGray}
                          alt="icon"
                          className={notesimageclass}
                        />
                      </Popover>
                    )}
                    <Popover
                      placement="bottom"
                      content={popoverContent}
                      trigger="click"
                      overlayClassName="edit-popover"
                      open={visible}
                      onOpenChange={handlePopoverVisibleChange}
                    >
                      <img src={dots} alt="dots" role="button" className="px-1 ms-3" />
                    </Popover>
                  </div>
                </>
          </div>
        </div>
        <Tooltip title={pdfname}>
          <div className="cursor-pointer" 
          onClick={(e) => handleEdit()}>
            <p
              className="fs18 poppins-medium text-gray-e mb-0 mt8 text-truncate"
              data-tip={pdfname}
            >
              {pdfname}
            </p>
          </div>
        </Tooltip>
        <div className="">
          <Tooltip title={receiver_name}>
            <div className="text-truncate mt8">
              <span className="text-gray-e text-wrap fs14">
                <span className="poppins-medium">{t('receiver')}:</span>
                <span className="text-truncate pl5">{receiver_name || "NA"}</span>
              </span>
            </div>
          </Tooltip>
        </div>
        <div
          className="card-body text-success"
          onClick={(e) => handleEdit()}
        >
          <div
            className={cardtitle}
          >
            <div className="d-flex align-items-center mw-60">
            <span className="text-capitalize d-flex align-items-center text-gray-e text-wrap fs14">
              <span className="poppins-medium me-2">{t('operator')}:</span>
              <Tooltip title={recentlyUpdatedBy}>
                <span className={`${recentlyUpdatedBy ? 'round-icon' : 'round-icon-empty font-400 fs14'}`}>{initials}</span>
              </Tooltip>
            </span>
              <span className="vertical-divider"></span>
              <span className={spanclassname}>{spanbodycontent}</span>
            </div>
          </div>

          <div className="d-flex align-items-center flex-nowrap gap-1">
            <div className="time-gray fs14 d-flex text-nowrap fs-sm-12"><img src={calendar} alt="" className="mr10" />
            {formatDate(extracted_time)}</div>
            {/*{pagenumber !== null && (
              <div className="dotblack d-none d-md-block"></div>
            )}*/}
            <span className="vertical-divider"></span>
            {extraction_status !== "invalid_file_format" && (
              <div className="time-gray fs14 d-flex text-nowrap fs-sm-12"><img src={noteIcon} alt="" className="mr10" />
              {pagenumber}</div>
            )}
          </div>
        </div>
      </div>
      {showdropdown && (
        <div className="text-decoration-none">
          <ul>
            <li>Edit</li>
            <li>Download</li>
            <li>Version History</li>
          </ul>
        </div>
      )}
    </>
  );
};
export default CustomCard;